<template>
  <div class="w-100">
    <b-container>
      <ImgBlock
        :title="$t('main.purchasePlan.designBlock.title')"
        :btn-text="$t('main.purchasePlan.designBlock.button')"
        :to="$trailingSlash(localePath('our-graphics'))"
      >
        <template #description> {{ $t('main.purchasePlan.designBlock.text') }} </template>
        <template #img>
          <picture>
            <source
              srcset="
                https://cdn.vexels.com/img/purchase-plan/design-we-get-almost.jpg?fmt=webp&w=300
              "
              type="image/webp"
              media="(max-width: 992px)"
            />

            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/design-we-get-almost.jpg?fmt=webp"
              type="image/webp"
            />

            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/design-we-get-almost.jpg"
              type="image/jpeg"
            />

            <img
              class="img-fluid"
              src="https://cdn.vexels.com/img/purchase-plan/design-we-get-almost.jpg"
              :alt="$t('main.purchasePlan.designBlock.altImage1')"
              height="525"
              width="446"
              loading="lazy"
            />
          </picture>
        </template>
      </ImgBlock>
    </b-container>

    <b-container>
      <ImgBlock
        :title="$t('main.purchasePlan.designBlock.title2')"
        :right="true"
        :btn-text="$t('main.purchasePlan.designBlock.button2')"
        to="https://www.vexels.com/blog/vexels-design-request-guide/"
      >
        <template #description> {{ $t('main.purchasePlan.designBlock.text2') }} </template>
        <template #img>
          <picture>
            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/cant-find.jpg?fmt=webp&w=300"
              type="image/webp"
              media="(max-width: 992px)"
            />

            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/cant-find.jpg?fmt=webp"
              type="image/webp"
            />

            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/cant-find.jpg"
              type="image/jpeg"
            />

            <img
              class="img-fluid"
              src="https://cdn.vexels.com/img/purchase-plan/cant-find.jpg"
              :alt="$t('main.purchasePlan.designBlock.altImage2')"
              height="525"
              width="446"
              loading="lazy"
            />
          </picture>
        </template>
      </ImgBlock>
    </b-container>

    <b-container>
      <ImgBlock :title="$t('main.purchasePlan.designBlock.title3')">
        <template #description>
          {{ $t('main.purchasePlan.designBlock.text3') }}
          <a target="_blank" href="https://mockups.vexels.com" rel="noopener noreferrer">{{
            $t('main.purchasePlan.designBlock.text4')
          }}</a
          >.
        </template>
        <template #img>
          <picture>
            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/mockup-gen.jpg?fmt=webp&w=300"
              type="image/webp"
              media="(max-width: 992px)"
            />

            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/mockup-gen.jpg?fmt=webp"
              type="image/webp"
            />

            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/mockup-gen.jpg"
              type="image/jpeg"
            />

            <img
              class="img-fluid"
              src="https://cdn.vexels.com/img/purchase-plan/mockup-gen.jpg"
              :alt="$t('main.purchasePlan.designBlock.altImage3')"
              height="525"
              width="446"
              loading="lazy"
            />
          </picture>
        </template>
      </ImgBlock>
    </b-container>

    <b-container>
      <ImgBlock :title="$t('main.purchasePlan.designBlock.title4')" :right="true">
        <template #description> {{ $t('main.purchasePlan.designBlock.text5') }} </template>
        <template #img>
          <picture>
            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/design-bundle.jpg?fmt=webp&w=300"
              type="image/webp"
              media="(max-width: 992px)"
            />

            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/design-bundle.jpg?fmt=webp"
              type="image/webp"
            />

            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/design-bundle.jpg"
              type="image/jpeg"
            />

            <img
              class="img-fluid"
              src="https://cdn.vexels.com/img/purchase-plan/design-bundle.jpg"
              :alt="$t('main.purchasePlan.designBlock.altImage4')"
              height="525"
              width="446"
              loading="lazy"
            />
          </picture>
        </template>
      </ImgBlock>
    </b-container>

    <b-container>
      <ImgBlock :title="$t('main.purchasePlan.designBlock.title5')">
        <template #description> {{ $t('main.purchasePlan.designBlock.text6') }} </template>
        <template #img>
          <picture>
            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/design-png.jpg?fmt=webp&w=300"
              type="image/webp"
              media="(max-width: 992px)"
            />

            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/design-png.jpg?fmt=webp"
              type="image/webp"
            />

            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/design-png.jpg"
              type="image/jpeg"
            />

            <img
              class="img-fluid"
              src="https://cdn.vexels.com/img/purchase-plan/design-png.jpg"
              :alt="$t('main.purchasePlan.designBlock.altImage5')"
              height="525"
              width="446"
              loading="lazy"
            />
          </picture>
        </template>
      </ImgBlock>
    </b-container>
  </div>
</template>

<script>
import ImgBlock from './ImgBlock';

export default {
  name: 'PurchasePlan',
  components: {
    ImgBlock
  }
};
</script>
